import { createFileRoute } from '@tanstack/react-router'
import node, {
  type accountAccessTokensPageQuery,
} from '#gen/relay/accountAccessTokensPageQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute(
  '/_dashboard/$account/settings/access-tokens',
)({
  staticData: { title: 'Access Tokens' },
  loader({ context, params }) {
    return context.preload<accountAccessTokensPageQuery>(node, params)
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/settings/account-access-tokens-page'),
    'AccountAccessTokensPage',
  ),
})
